const SESSION_KEY_PREFIX = "atomicpay:storefront:customer-session:";

function getSessionKey(storeSlug) {
  return `${SESSION_KEY_PREFIX}${encodeURIComponent(storeSlug)}`;
}

export function getCustomerSessionToken(storeSlug) {
  return window.sessionStorage.getItem(getSessionKey(storeSlug));
}

export function setCustomerSessionToken(storeSlug, sessionToken) {
  if (typeof sessionToken !== "string" || sessionToken.length === 0) {
    throw new TypeError("A valid session token is required.");
  }

  window.sessionStorage.setItem(getSessionKey(storeSlug), sessionToken);
}

export function clearCustomerSessionToken(storeSlug) {
  window.sessionStorage.removeItem(getSessionKey(storeSlug));
}
